import { Component } from '@angular/core';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { InvoiceService } from 'src/app/services/invoice.service';

@Component({
    selector: 'app-generic-statement',
    templateUrl: './generic-statement.component.html',
    styleUrls: ['./generic-statement.component.scss'],
    standalone: false
})
export class GenericStatementComponent {
     isDownloading: boolean = false;
     periodList: string[] = [];
     companyType: string = 'MC';
     billingPeriod: string = '';
     loginEmail: string = '';
     reportType: string = 'PDF';
     reportLevel: string = '1';
     showTotals: string = '0';
     orderByLogin: string = '0';
     customerId: string = '';
     userProfile?: UserProfile;
     showReportDownloadedAlert: boolean = false;

     constructor(public generalService: GeneralService,
          private authenticationService: AuthenticationService, public invoiceService: InvoiceService) {
          this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
          this.customerId = this.userProfile!.customerId;
          this.loginEmail = this.userProfile!.userData.userName;
          this.periodList = invoiceService.getCdbBillingCyclesList();
          this.billingPeriod = this.periodList[0];

          this.scrollToTop();
     }

     pageValid(): boolean {
          if (this.billingPeriod && this.loginEmail && Number(this.customerId) && this.showTotals && this.orderByLogin ) {
               return true;
          }
          return false;
     }

     downloadReport() {
          if (this.billingPeriod === '') {
               console.error("No billing period selected");
               return;
          }

          this.isDownloading = true;
          const userProfile = this.authenticationService.getUserProfile() as UserProfile;
          this.invoiceService.GetGenericStatementReport(Number(this.customerId), this.billingPeriod).subscribe((result: any) => {
               const filename = `GenericStatementReport-${this.billingPeriod}.pdf`;
               const element = document.createElement('a');
               element.setAttribute('href', 'data:application/octet-stream;base64,' + result);
               element.setAttribute('download', filename);
               element.style.display = 'none';
               document.body.appendChild(element);
               element.click();
               document.body.removeChild(element);
               this.isDownloading = false;
               this.showReportDownloadedAlert = true;
          });
     }

     openDocument(docName: string) {
          this.generalService.openDocument(docName);
     }



     scrollToTop() {
          window.scrollTo(0, 0);
     }
}
